import { CommonModule } from '@angular/common';
import { Component, EventEmitter, Input, Output } from '@angular/core';

@Component({
  selector: 'app-rfebm-icon-button',
  templateUrl: 'rfebm-icon-button.component.html',
  styleUrls: ['rfebm-icon-button.component.scss'],
  standalone: true,
  imports: [CommonModule]
})
export class RfebmIconButtonComponent {

  @Input() iconName: string = 'video';

  @Output() onClick: EventEmitter<void> = new EventEmitter<void>();

  constructor() { }

  protected handleClick(): void {
    this.onClick.emit();
  }

}
